
import React from 'react';
import { Route, Routes } from "react-router-dom";
import './App.css';




//__________________________________________________________
//                  Constet
import { WhatsappProvider } from "./components/whatsapp/WhatsappContext";

import Sidebar from './components/Helper/sidebarr';
//__________________________________________________________
//                  Pages
import Error from "./components/Home/error";
import Home from "./components/Home/home";
import Login from "./components/Home/login";
import Logout from "./components/Home/logout";
import VisitorLogin from "./components/Home/visitor_login";

import Booking from "./components/bookings/addition/booking";
import PaymentsDay from './components/bookings/payments/views/payments_day';
import PaymentsMonth from './components/bookings/payments/views/payments_month';
import PaymentsYear from './components/bookings/payments/views/payments_year';
import PaymentsTransfers from './components/bookings/payments/views/Payments_via_bank_transfers';

import BookingEdit from './components/bookings/update/edit_reservation';
import Bookinges from './components/bookings/view/bookinges';

import BookingService from './components/booking-services/addition/booking_services';
import BookingServices from './components/booking-services/view/bookinges_services';
import ServiceDashboard from './components/booking-services/view/ServiceDashboard';
import AdminDashboard from './components/dashboard/AdminDashboard';

import Apartments from './components/apartments/apartments';

import CustomerNew from "./components/customers/customer_new";
import Customers from "./components/customers/customers";


import CustomersApp from "./components/users-app/customers_app";
import UsersApp from "./components/users-app/users_app";
import UsersAppActive from "./components/users-app/users_app_active";

import Users from "./components/users/users";
import UsersTracking from "./components/users/usersTracking";

import ReportBookinges from "./components/reports/report_bookinges";
import ReportCheck from "./components/reports/report_check";
import CheckStatus from "./components/bookings/check_status";
import ReportServiceSummary from "./components/reports/services/report_summary";
import ReportReservationes from "./components/reports/report_reservationes";

import SystemSetUp from "./components/system/setup";
function App() {

  // if ("serviceWorker" in navigator) {
  //   navigator.serviceWorker.register("/firebase-messaging-sw.js")
  //     .then((registration) => {
  //       console.log("✅ Service Worker مسجل بنجاح:", registration.scope);
  //     })
  //     .catch((error) => {
  //       console.error("❌ فشل تسجيل Service Worker:", error);
  //     });
  // }

  const TOKEN = window.localStorage.getItem('isLogIn');
  return (
    <>
      <Routes basename="/">
        <Route path="/" element={TOKEN ? <WhatsappProvider><Sidebar /><Home /></WhatsappProvider> : <Login />} />
        <Route path="/404" element={<><Error /></>} />

        <Route path="/*" element={<><Error /></>} />
        <Route path="/login" element={<Login />} />
        <Route path="/bracelet-login" element={TOKEN ? <VisitorLogin></VisitorLogin> : <Logout />} />

        <Route path="/error" element={<><Error /></>} />
        <Route path="/logout" element={<><Logout /></>} />
        <Route path="/home" element={TOKEN ? <WhatsappProvider> <Sidebar /> <Home /></WhatsappProvider> : <Login />} />
        <Route path="/booking" element={TOKEN ? <WhatsappProvider><Sidebar /><Booking /></WhatsappProvider> : <Login />} />
        <Route path="/booking-service" element={TOKEN ? <WhatsappProvider><Sidebar /><BookingService /></WhatsappProvider> : <Login />} />
        <Route path="/bookings" element={TOKEN ? <WhatsappProvider><Sidebar /><Bookinges /></WhatsappProvider> : <Login />} />
        <Route path="/bookings-services" element={TOKEN ? <WhatsappProvider><Sidebar /><BookingServices /></WhatsappProvider> : <Login />} />
        <Route path="/service-dashboard" element={TOKEN ? <WhatsappProvider><Sidebar /><ServiceDashboard /></WhatsappProvider> : <Login />} />
        <Route path="/admin-dashboard" element={TOKEN ? <AdminDashboard /> : <Login />} />
        <Route path="/apartments" element={TOKEN ? <WhatsappProvider><Sidebar /><Apartments /></WhatsappProvider> : <Login />} />

        <Route path="/bookings-edit" element={TOKEN ? <WhatsappProvider><Sidebar /><BookingEdit /></WhatsappProvider> : <Login />} />

        <Route path="/payments-day" element={TOKEN ? <WhatsappProvider><Sidebar /><PaymentsDay /></WhatsappProvider> : <Login />} />
        <Route path="/payments-month" element={TOKEN ? <WhatsappProvider><Sidebar /><PaymentsMonth /></WhatsappProvider> : <Login />} />
        <Route path="/payments-year" element={TOKEN ? <WhatsappProvider><Sidebar /><PaymentsYear /></WhatsappProvider> : <Login />} />
        <Route path="/payments-transfers" element={TOKEN ? <WhatsappProvider><Sidebar /><PaymentsTransfers /></WhatsappProvider> : <Login />} />

        {/* <Route path="/payment_receipt" element={<PaymentReceipt><Sidebar /><Users /></PaymentReceipt>} /> */}

        <Route path="/customer-new" element={TOKEN ? <WhatsappProvider><Sidebar /><CustomerNew /></WhatsappProvider> : <Login />} />
        <Route path="/customers" element={TOKEN ? <WhatsappProvider><Sidebar /><Customers /></WhatsappProvider> : <Login />} />
        <Route path="/users-app" element={TOKEN ? <WhatsappProvider><Sidebar /><UsersApp /></WhatsappProvider> : <Login />} />
        <Route path="/users-app-active" element={TOKEN ? <WhatsappProvider><Sidebar /><UsersAppActive /></WhatsappProvider> : <Login />} />

        <Route path="/users-app-customers" element={TOKEN ? <WhatsappProvider><Sidebar /><CustomersApp /></WhatsappProvider> : <Login />} />

        <Route path="/users" element={TOKEN ? <WhatsappProvider><Sidebar /><Users /></WhatsappProvider> : <Login />} />
        <Route path="/users-tracking" element={TOKEN ? <WhatsappProvider><Sidebar /><UsersTracking /></WhatsappProvider> : <Login />} />
        <Route path="/system-setup" element={TOKEN ? <WhatsappProvider><Sidebar /><SystemSetUp /></WhatsappProvider> : <Login />} />

        <Route path="/report_bookinges" element={TOKEN ? <WhatsappProvider><Sidebar /><ReportBookinges /></WhatsappProvider> : <Login />} />
        <Route path="/report-reservationes" element={TOKEN ? <WhatsappProvider><Sidebar /><ReportReservationes /></WhatsappProvider> : <Login />} />


        <Route path="/report-check" element={TOKEN ? <WhatsappProvider><Sidebar /><ReportCheck /></WhatsappProvider> : <Login />} />
        <Route path="/check-status" element={TOKEN ? <WhatsappProvider><Sidebar /><CheckStatus /></WhatsappProvider> : <Login />} />
        <Route path="/report-service-summary" element={TOKEN ? <WhatsappProvider><Sidebar /><ReportServiceSummary /></WhatsappProvider> : <Login />} />

      </Routes>
    </>
  );
}

export default App;
